/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Message } from '../models';
// @ts-ignore
import { TrackAndTrace } from '../models';
/**
 * TrackAndTraceService - axios parameter creator
 * @export
 */
export const TrackAndTraceServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert Track and trace zu einem Auftrag 
         * @summary TT-Informationen
         * @param {string} webtoken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackAndTrace: async (webtoken: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'webtoken' is not null or undefined
            assertParamExists('getTrackAndTrace', 'webtoken', webtoken)
            const localVarPath = `/api/history/{webtoken}`
                .replace(`{${"webtoken"}}`, encodeURIComponent(String(webtoken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert Track and trace zu einem Auftrag Anhand der AbNr (Zeichennummer)
         * @summary TT-Informationen
         * @param {string} abnr 
         * @param {string} absmatchcode 
         * @param {string} plz 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackAndTraceByAbNrAndAbsenderMatchcode: async (abnr: string, absmatchcode: string, plz: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'abnr' is not null or undefined
            assertParamExists('getTrackAndTraceByAbNrAndAbsenderMatchcode', 'abnr', abnr)
            // verify required parameter 'absmatchcode' is not null or undefined
            assertParamExists('getTrackAndTraceByAbNrAndAbsenderMatchcode', 'absmatchcode', absmatchcode)
            // verify required parameter 'plz' is not null or undefined
            assertParamExists('getTrackAndTraceByAbNrAndAbsenderMatchcode', 'plz', plz)
            const localVarPath = `/api/history/abnr/{abnr}/absmatchcode{absmatchcode},plz/{plz}`
                .replace(`{${"abnr"}}`, encodeURIComponent(String(abnr)))
                .replace(`{${"absmatchcode"}}`, encodeURIComponent(String(absmatchcode)))
                .replace(`{${"plz"}}`, encodeURIComponent(String(plz)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert Track and trace zu einem Auftrag Anhand der AbNr (Zeichennummer)
         * @summary TT-Informationen
         * @param {string} abnr 
         * @param {string} empmatchcode 
         * @param {string} plz 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackAndTraceByAbnr: async (abnr: string, empmatchcode: string, plz: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'abnr' is not null or undefined
            assertParamExists('getTrackAndTraceByAbnr', 'abnr', abnr)
            // verify required parameter 'empmatchcode' is not null or undefined
            assertParamExists('getTrackAndTraceByAbnr', 'empmatchcode', empmatchcode)
            // verify required parameter 'plz' is not null or undefined
            assertParamExists('getTrackAndTraceByAbnr', 'plz', plz)
            const localVarPath = `/api/history/abnr/{abnr}/empfmatchcode{empmatchcode},plz/{plz}`
                .replace(`{${"abnr"}}`, encodeURIComponent(String(abnr)))
                .replace(`{${"empmatchcode"}}`, encodeURIComponent(String(empmatchcode)))
                .replace(`{${"plz"}}`, encodeURIComponent(String(plz)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert Track and trace zu einem Auftrag anhand der MandantId und der  Referenznummer
         * @summary TT-Informationen
         * @param {string} matchcode 
         * @param {string} referenznr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackAndTraceByMandantAndReferenzNr: async (matchcode: string, referenznr: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matchcode' is not null or undefined
            assertParamExists('getTrackAndTraceByMandantAndReferenzNr', 'matchcode', matchcode)
            // verify required parameter 'referenznr' is not null or undefined
            assertParamExists('getTrackAndTraceByMandantAndReferenzNr', 'referenznr', referenznr)
            const localVarPath = `/api/history/matchcode/{matchcode}/referenznr/{referenznr}`
                .replace(`{${"matchcode"}}`, encodeURIComponent(String(matchcode)))
                .replace(`{${"referenznr"}}`, encodeURIComponent(String(referenznr)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert Track and trace zu einem Auftrag anhand der Referenznummer
         * @summary TT-Informationen
         * @param {string} referenznr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackAndTraceByReferenznr: async (referenznr: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'referenznr' is not null or undefined
            assertParamExists('getTrackAndTraceByReferenznr', 'referenznr', referenznr)
            const localVarPath = `/api/history/referenznr/{referenznr}`
                .replace(`{${"referenznr"}}`, encodeURIComponent(String(referenznr)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert Track and trace zu einem Auftrag 
         * @summary TT-Informationen
         * @param {string} spedeigennr 
         * @param {string} plz 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackAndTraceBySpedeigennr: async (spedeigennr: string, plz: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'spedeigennr' is not null or undefined
            assertParamExists('getTrackAndTraceBySpedeigennr', 'spedeigennr', spedeigennr)
            // verify required parameter 'plz' is not null or undefined
            assertParamExists('getTrackAndTraceBySpedeigennr', 'plz', plz)
            const localVarPath = `/api/history/spedeigennr/{spedeigennr}/plz/{plz}`
                .replace(`{${"spedeigennr"}}`, encodeURIComponent(String(spedeigennr)))
                .replace(`{${"plz"}}`, encodeURIComponent(String(plz)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert Track and trace zu einem Auftrag 
         * @summary TT-Informationen
         * @param {string} [spedeigennrOrAbnr] 
         * @param {string} [empfaengerplz] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackAndTraceBySpedeigennrOrAbnr: async (spedeigennrOrAbnr?: string, empfaengerplz?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (spedeigennrOrAbnr !== undefined) {
                localVarQueryParameter['spedeigennrOrAbnr'] = spedeigennrOrAbnr;
            }

            if (empfaengerplz !== undefined) {
                localVarQueryParameter['empfaengerplz'] = empfaengerplz;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert Track and trace zu einem Auftrag 
         * @summary TT-Informationen
         * @param {string} [spedeigennrOrReferenz] 
         * @param {string} [empfaengerplz] 
         * @param {string} [datumvon] 
         * @param {string} [datumbis] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackAndTraceBySpedeigennrOrReferenz: async (spedeigennrOrReferenz?: string, empfaengerplz?: string, datumvon?: string, datumbis?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/history/ref`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (spedeigennrOrReferenz !== undefined) {
                localVarQueryParameter['spedeigennrOrReferenz'] = spedeigennrOrReferenz;
            }

            if (empfaengerplz !== undefined) {
                localVarQueryParameter['empfaengerplz'] = empfaengerplz;
            }

            if (datumvon !== undefined) {
                localVarQueryParameter['datumvon'] = datumvon;
            }

            if (datumbis !== undefined) {
                localVarQueryParameter['datumbis'] = datumbis;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrackAndTraceService - functional programming interface
 * @export
 */
export const TrackAndTraceServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrackAndTraceServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert Track and trace zu einem Auftrag 
         * @summary TT-Informationen
         * @param {string} webtoken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackAndTrace(webtoken: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrackAndTrace>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackAndTrace(webtoken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert Track and trace zu einem Auftrag Anhand der AbNr (Zeichennummer)
         * @summary TT-Informationen
         * @param {string} abnr 
         * @param {string} absmatchcode 
         * @param {string} plz 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackAndTraceByAbNrAndAbsenderMatchcode(abnr: string, absmatchcode: string, plz: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrackAndTrace>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackAndTraceByAbNrAndAbsenderMatchcode(abnr, absmatchcode, plz, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert Track and trace zu einem Auftrag Anhand der AbNr (Zeichennummer)
         * @summary TT-Informationen
         * @param {string} abnr 
         * @param {string} empmatchcode 
         * @param {string} plz 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackAndTraceByAbnr(abnr: string, empmatchcode: string, plz: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrackAndTrace>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackAndTraceByAbnr(abnr, empmatchcode, plz, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert Track and trace zu einem Auftrag anhand der MandantId und der  Referenznummer
         * @summary TT-Informationen
         * @param {string} matchcode 
         * @param {string} referenznr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackAndTraceByMandantAndReferenzNr(matchcode: string, referenznr: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrackAndTrace>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackAndTraceByMandantAndReferenzNr(matchcode, referenznr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert Track and trace zu einem Auftrag anhand der Referenznummer
         * @summary TT-Informationen
         * @param {string} referenznr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackAndTraceByReferenznr(referenznr: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrackAndTrace>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackAndTraceByReferenznr(referenznr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert Track and trace zu einem Auftrag 
         * @summary TT-Informationen
         * @param {string} spedeigennr 
         * @param {string} plz 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackAndTraceBySpedeigennr(spedeigennr: string, plz: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrackAndTrace>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackAndTraceBySpedeigennr(spedeigennr, plz, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert Track and trace zu einem Auftrag 
         * @summary TT-Informationen
         * @param {string} [spedeigennrOrAbnr] 
         * @param {string} [empfaengerplz] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackAndTraceBySpedeigennrOrAbnr(spedeigennrOrAbnr?: string, empfaengerplz?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrackAndTrace>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackAndTraceBySpedeigennrOrAbnr(spedeigennrOrAbnr, empfaengerplz, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert Track and trace zu einem Auftrag 
         * @summary TT-Informationen
         * @param {string} [spedeigennrOrReferenz] 
         * @param {string} [empfaengerplz] 
         * @param {string} [datumvon] 
         * @param {string} [datumbis] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackAndTraceBySpedeigennrOrReferenz(spedeigennrOrReferenz?: string, empfaengerplz?: string, datumvon?: string, datumbis?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrackAndTrace>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackAndTraceBySpedeigennrOrReferenz(spedeigennrOrReferenz, empfaengerplz, datumvon, datumbis, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TrackAndTraceService - factory interface
 * @export
 */
export const TrackAndTraceServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrackAndTraceServiceFp(configuration)
    return {
        /**
         * Liefert Track and trace zu einem Auftrag 
         * @summary TT-Informationen
         * @param {string} webtoken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackAndTrace(webtoken: string, options?: any): AxiosPromise<Array<TrackAndTrace>> {
            return localVarFp.getTrackAndTrace(webtoken, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert Track and trace zu einem Auftrag Anhand der AbNr (Zeichennummer)
         * @summary TT-Informationen
         * @param {string} abnr 
         * @param {string} absmatchcode 
         * @param {string} plz 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackAndTraceByAbNrAndAbsenderMatchcode(abnr: string, absmatchcode: string, plz: string, options?: any): AxiosPromise<Array<TrackAndTrace>> {
            return localVarFp.getTrackAndTraceByAbNrAndAbsenderMatchcode(abnr, absmatchcode, plz, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert Track and trace zu einem Auftrag Anhand der AbNr (Zeichennummer)
         * @summary TT-Informationen
         * @param {string} abnr 
         * @param {string} empmatchcode 
         * @param {string} plz 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackAndTraceByAbnr(abnr: string, empmatchcode: string, plz: string, options?: any): AxiosPromise<Array<TrackAndTrace>> {
            return localVarFp.getTrackAndTraceByAbnr(abnr, empmatchcode, plz, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert Track and trace zu einem Auftrag anhand der MandantId und der  Referenznummer
         * @summary TT-Informationen
         * @param {string} matchcode 
         * @param {string} referenznr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackAndTraceByMandantAndReferenzNr(matchcode: string, referenznr: string, options?: any): AxiosPromise<Array<TrackAndTrace>> {
            return localVarFp.getTrackAndTraceByMandantAndReferenzNr(matchcode, referenznr, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert Track and trace zu einem Auftrag anhand der Referenznummer
         * @summary TT-Informationen
         * @param {string} referenznr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackAndTraceByReferenznr(referenznr: string, options?: any): AxiosPromise<Array<TrackAndTrace>> {
            return localVarFp.getTrackAndTraceByReferenznr(referenznr, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert Track and trace zu einem Auftrag 
         * @summary TT-Informationen
         * @param {string} spedeigennr 
         * @param {string} plz 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackAndTraceBySpedeigennr(spedeigennr: string, plz: string, options?: any): AxiosPromise<Array<TrackAndTrace>> {
            return localVarFp.getTrackAndTraceBySpedeigennr(spedeigennr, plz, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert Track and trace zu einem Auftrag 
         * @summary TT-Informationen
         * @param {string} [spedeigennrOrAbnr] 
         * @param {string} [empfaengerplz] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackAndTraceBySpedeigennrOrAbnr(spedeigennrOrAbnr?: string, empfaengerplz?: string, options?: any): AxiosPromise<Array<TrackAndTrace>> {
            return localVarFp.getTrackAndTraceBySpedeigennrOrAbnr(spedeigennrOrAbnr, empfaengerplz, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert Track and trace zu einem Auftrag 
         * @summary TT-Informationen
         * @param {string} [spedeigennrOrReferenz] 
         * @param {string} [empfaengerplz] 
         * @param {string} [datumvon] 
         * @param {string} [datumbis] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackAndTraceBySpedeigennrOrReferenz(spedeigennrOrReferenz?: string, empfaengerplz?: string, datumvon?: string, datumbis?: string, options?: any): AxiosPromise<Array<TrackAndTrace>> {
            return localVarFp.getTrackAndTraceBySpedeigennrOrReferenz(spedeigennrOrReferenz, empfaengerplz, datumvon, datumbis, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrackAndTraceService - interface
 * @export
 * @interface TrackAndTraceService
 */
export interface TrackAndTraceServiceInterface {
    /**
     * Liefert Track and trace zu einem Auftrag 
     * @summary TT-Informationen
     * @param {string} webtoken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackAndTraceServiceInterface
     */
    getTrackAndTrace(webtoken: string, options?: any): AxiosPromise<Array<TrackAndTrace>>;

    /**
     * Liefert Track and trace zu einem Auftrag Anhand der AbNr (Zeichennummer)
     * @summary TT-Informationen
     * @param {string} abnr 
     * @param {string} absmatchcode 
     * @param {string} plz 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackAndTraceServiceInterface
     */
    getTrackAndTraceByAbNrAndAbsenderMatchcode(abnr: string, absmatchcode: string, plz: string, options?: any): AxiosPromise<Array<TrackAndTrace>>;

    /**
     * Liefert Track and trace zu einem Auftrag Anhand der AbNr (Zeichennummer)
     * @summary TT-Informationen
     * @param {string} abnr 
     * @param {string} empmatchcode 
     * @param {string} plz 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackAndTraceServiceInterface
     */
    getTrackAndTraceByAbnr(abnr: string, empmatchcode: string, plz: string, options?: any): AxiosPromise<Array<TrackAndTrace>>;

    /**
     * Liefert Track and trace zu einem Auftrag anhand der MandantId und der  Referenznummer
     * @summary TT-Informationen
     * @param {string} matchcode 
     * @param {string} referenznr 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackAndTraceServiceInterface
     */
    getTrackAndTraceByMandantAndReferenzNr(matchcode: string, referenznr: string, options?: any): AxiosPromise<Array<TrackAndTrace>>;

    /**
     * Liefert Track and trace zu einem Auftrag anhand der Referenznummer
     * @summary TT-Informationen
     * @param {string} referenznr 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackAndTraceServiceInterface
     */
    getTrackAndTraceByReferenznr(referenznr: string, options?: any): AxiosPromise<Array<TrackAndTrace>>;

    /**
     * Liefert Track and trace zu einem Auftrag 
     * @summary TT-Informationen
     * @param {string} spedeigennr 
     * @param {string} plz 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackAndTraceServiceInterface
     */
    getTrackAndTraceBySpedeigennr(spedeigennr: string, plz: string, options?: any): AxiosPromise<Array<TrackAndTrace>>;

    /**
     * Liefert Track and trace zu einem Auftrag 
     * @summary TT-Informationen
     * @param {string} [spedeigennrOrAbnr] 
     * @param {string} [empfaengerplz] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackAndTraceServiceInterface
     */
    getTrackAndTraceBySpedeigennrOrAbnr(spedeigennrOrAbnr?: string, empfaengerplz?: string, options?: any): AxiosPromise<Array<TrackAndTrace>>;

    /**
     * Liefert Track and trace zu einem Auftrag 
     * @summary TT-Informationen
     * @param {string} [spedeigennrOrReferenz] 
     * @param {string} [empfaengerplz] 
     * @param {string} [datumvon] 
     * @param {string} [datumbis] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackAndTraceServiceInterface
     */
    getTrackAndTraceBySpedeigennrOrReferenz(spedeigennrOrReferenz?: string, empfaengerplz?: string, datumvon?: string, datumbis?: string, options?: any): AxiosPromise<Array<TrackAndTrace>>;

}

/**
 * TrackAndTraceService - object-oriented interface
 * @export
 * @class TrackAndTraceService
 * @extends {BaseAPI}
 */
export class TrackAndTraceService extends BaseAPI implements TrackAndTraceServiceInterface {
    /**
     * Liefert Track and trace zu einem Auftrag 
     * @summary TT-Informationen
     * @param {string} webtoken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackAndTraceService
     */
    public getTrackAndTrace(webtoken: string, options?: any) {
        return TrackAndTraceServiceFp(this.configuration).getTrackAndTrace(webtoken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert Track and trace zu einem Auftrag Anhand der AbNr (Zeichennummer)
     * @summary TT-Informationen
     * @param {string} abnr 
     * @param {string} absmatchcode 
     * @param {string} plz 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackAndTraceService
     */
    public getTrackAndTraceByAbNrAndAbsenderMatchcode(abnr: string, absmatchcode: string, plz: string, options?: any) {
        return TrackAndTraceServiceFp(this.configuration).getTrackAndTraceByAbNrAndAbsenderMatchcode(abnr, absmatchcode, plz, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert Track and trace zu einem Auftrag Anhand der AbNr (Zeichennummer)
     * @summary TT-Informationen
     * @param {string} abnr 
     * @param {string} empmatchcode 
     * @param {string} plz 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackAndTraceService
     */
    public getTrackAndTraceByAbnr(abnr: string, empmatchcode: string, plz: string, options?: any) {
        return TrackAndTraceServiceFp(this.configuration).getTrackAndTraceByAbnr(abnr, empmatchcode, plz, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert Track and trace zu einem Auftrag anhand der MandantId und der  Referenznummer
     * @summary TT-Informationen
     * @param {string} matchcode 
     * @param {string} referenznr 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackAndTraceService
     */
    public getTrackAndTraceByMandantAndReferenzNr(matchcode: string, referenznr: string, options?: any) {
        return TrackAndTraceServiceFp(this.configuration).getTrackAndTraceByMandantAndReferenzNr(matchcode, referenznr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert Track and trace zu einem Auftrag anhand der Referenznummer
     * @summary TT-Informationen
     * @param {string} referenznr 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackAndTraceService
     */
    public getTrackAndTraceByReferenznr(referenznr: string, options?: any) {
        return TrackAndTraceServiceFp(this.configuration).getTrackAndTraceByReferenznr(referenznr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert Track and trace zu einem Auftrag 
     * @summary TT-Informationen
     * @param {string} spedeigennr 
     * @param {string} plz 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackAndTraceService
     */
    public getTrackAndTraceBySpedeigennr(spedeigennr: string, plz: string, options?: any) {
        return TrackAndTraceServiceFp(this.configuration).getTrackAndTraceBySpedeigennr(spedeigennr, plz, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert Track and trace zu einem Auftrag 
     * @summary TT-Informationen
     * @param {string} [spedeigennrOrAbnr] 
     * @param {string} [empfaengerplz] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackAndTraceService
     */
    public getTrackAndTraceBySpedeigennrOrAbnr(spedeigennrOrAbnr?: string, empfaengerplz?: string, options?: any) {
        return TrackAndTraceServiceFp(this.configuration).getTrackAndTraceBySpedeigennrOrAbnr(spedeigennrOrAbnr, empfaengerplz, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert Track and trace zu einem Auftrag 
     * @summary TT-Informationen
     * @param {string} [spedeigennrOrReferenz] 
     * @param {string} [empfaengerplz] 
     * @param {string} [datumvon] 
     * @param {string} [datumbis] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackAndTraceService
     */
    public getTrackAndTraceBySpedeigennrOrReferenz(spedeigennrOrReferenz?: string, empfaengerplz?: string, datumvon?: string, datumbis?: string, options?: any) {
        return TrackAndTraceServiceFp(this.configuration).getTrackAndTraceBySpedeigennrOrReferenz(spedeigennrOrReferenz, empfaengerplz, datumvon, datumbis, options).then((request) => request(this.axios, this.basePath));
    }
}
